export const locale = {
    lang: "pt-BR",
    data: {
        NOTIFICATION: {
            TITLE: "Notificação",

            APP_HAS_NOTIFICATIONS: "Você possui {{count}} notificações no APP!",
            APP_HAS_NOTIFICATION: "Você possui 1 notificação no APP!",
            GO_TO_APP: "Ir para o APP",

            CERTIFICATE_EXPORT_COMPLETED: "Certificados exportados com sucesso!",
            USER_IMPORT_SUCCESS: "Usuários importados com sucesso!",
            USER_EXPORT_COMPLETED: "Usuários exportados com sucesso!",
            DOWNLOAD: "BAIXAR"
        }
    }
};
